import { GetterTree } from "vuex";
import { ScoreState } from "../types";
import { IRootState, IRootGetters } from "../../types";
import { RiskLevel } from "@dcc/types/riskLevel";

import { getRiskLevel, getAmountAboveLowRisk } from "@dcc/score/riskLevel";
import { IScoreGetters } from "./types";
import { GetterNames } from "./names";

export const getters: GetterTree<ScoreState, IRootState> = {
  [GetterNames.RISKLEVEL](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): RiskLevel {
    const weeklyUnitsAndCalories = getters[GetterNames.WEEKLYUNITSANDCALORIES];
    const gender = rootGetters["profile/gender"];

    return gender !== undefined
      ? getRiskLevel(weeklyUnitsAndCalories.units, gender)
      : RiskLevel.Low;
  },
  [GetterNames.RISKLEVELBEFORECHANGES](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): RiskLevel {
    const weeklyUnitsAndCalories =
      getters[GetterNames.ORIGINALWEEKLYUNITSANDCALORIES];
    const gender = rootGetters["profile/gender"];

    return gender !== undefined
      ? getRiskLevel(weeklyUnitsAndCalories.units, gender)
      : RiskLevel.Low;
  },
  [GetterNames.AMOUNTABOVELOWRISK](
    state: ScoreState,
    getters: IScoreGetters
  ): number {
    const riskLevel = getters[GetterNames.RISKLEVEL];
    const weeklyUnitsAndCalories = getters[GetterNames.WEEKLYUNITSANDCALORIES];
    return getAmountAboveLowRisk(riskLevel, weeklyUnitsAndCalories.units);
  }
};
